module.exports = __webpack_public_path__ + "img/thumb_22.4e7b1310.jpg";